export const DERIVATION_PATH = {
  Deprecated: 'deprecated',
  Bip44: 'bip44',
  Bip44Change: 'bip44Change',
};
